export type Point = { readonly x: number; readonly y: number };
export const MAX_STROKE_POINTS = 512;
export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export function normalizedPoint(x: number, y: number, bounds: { left: number; top: number; width: number; height: number }): Point {
  if (!(bounds.width > 0 && bounds.height > 0)) throw new Error("标注画布尚未就绪");
  return { x: clamp((x - bounds.left) / bounds.width, 0, 1), y: clamp((y - bounds.top) / bounds.height, 0, 1) };
}
export function rectangleBetween(a: Point, b: Point) {
  const x = Math.min(a.x, b.x); const y = Math.min(a.y, b.y);
  const width = Math.min(Math.abs(a.x - b.x), 1 - x); const height = Math.min(Math.abs(a.y - b.y), 1 - y);
  return width >= 0.002 && height >= 0.002 ? { x, y, width, height } : null;
}
/** Bounded sampling keeps the first point and recent detail without growing metadata without limit. */
export function appendPoint(points: readonly Point[], point: Point): Point[] {
  const last = points.at(-1);
  if (last && Math.hypot(last.x - point.x, last.y - point.y) < 0.002) return [...points];
  const compact = points.length >= MAX_STROKE_POINTS ? points.filter((_, index) => index % 2 === 0) : points;
  return [...compact, point];
}
export const seconds = (ms: number) => (ms / 1000).toFixed(3);
export function formatTime(ms: number): string {
  const whole = Math.floor(ms / 1000);
  return `${Math.floor(whole / 60).toString().padStart(2, "0")}:${(whole % 60).toString().padStart(2, "0")}.${Math.floor(ms % 1000 / 100).toString()}`;
}
export function errorMessage(error: unknown): string {
  if (typeof error === "object" && error !== null && "_tag" in error && error._tag === "Cancelled") return "操作已取消，临时文件正在清理或已清理。";
  if (typeof error === "object" && error !== null && "_tag" in error && error._tag === "RevisionConflict") return "工程已在另一个页面更新，当前修改尚未保存。「恢复最近」将载入浏览器中的版本。";
  if (typeof error === "object" && error !== null && "_tag" in error && error._tag === "EngineError" && "message" in error && String(error.message).includes("no drawable skeleton remains")) return "这张图片没有可绘制的线条。请换用清晰线稿、检查保护区，或添加手工笔画后重试。";
  if (error instanceof Error) return error.message;
  if (typeof error === "object" && error !== null && "message" in error) return String(error.message);
  return String(error);
}

export const isCancelled = (error: unknown): boolean => typeof error === "object" && error !== null && "_tag" in error && error._tag === "Cancelled";
